export default "__VITE_ASSET__Bql0mmlk__"